/* eslint-disable max-len */
export default {
  ACTIONS: {
    FINISH: 'Finalizar',
    NEXT: 'Siguiente'
  },
  ERRORS: {
    GREATER_THAN: 'No debe ser mayor que {max}.',
    INVALID_PROZIS_POINTS:
      '¡Vaya! Los ProzisPoints que quieres compartir con el mensajero ya no están disponibles. Inténtalo de nuevo.',
    LESS_THAN: 'No debe ser menor que {min}.',
    MAX_CHARACTERS: 'La descripción debe tener un máximo de {max} caracteres.',
    REQUIRED: 'Campo necesario.',
    VALIDATING_CODE: 'No se ha podido validar el código {code}.'
  },
  LABELS: {
    COMMENT: 'Comentario',
    COURIER: 'mensajero',
    ERROR: 'Error',
    EXPERIENCE_EVALUATION: 'CALIFICA LA EXPERIENCIA DE ENTREGA',
    MORE_TO_SAY: 'IMPROVE OURSELVES',
    OTHER: 'Otro',
    PROZIS_NOW: 'PROZIS NOW'
  },
  SENTENCES: {
    AMAZED:
      '😁 Nos alegra saber que todo ha ido bien. ¿Qué es lo que más te ha gustado?',
    ANSWERED_SURVEY:
      'Ya hemos recibido tus comentarios sobre la entrega del pedido {code}. \n\rNos gustaría recibir tus comentarios sobre tus experiencias futuras. 👍',
    ENTITY: '¿Qué te ha parecido {entity}?',
    POINTS: 'Tienes {points} ProzisPoints.',
    SATISFIED:
      '😁 Nos alegra saber que todo ha ido bien, ¿pero cómo podemos mejorar?',
    SHARE_POINTS:
      '¿Te gustaría agradecer a {entity}? Comparte tus ProzisPoints con él/ella. 🙂',
    THANKS: '😀 Gracias, {name}.',
    UNHAPPY:
      '😔 Sentimos que la entrega no haya sido como esperabas. ¿Qué ha ido mal?'
  }
};
